import React, { FC } from 'react';
import './hashTagList.module.scss';
import { ATTRIBUTE_TAGS, CATEGORY_TAGS } from '../../organisms/events/states/EventListState';

type Props = {
  tags: string[];
};

export const HashTagList: FC<Props> = ({ tags }) => {
  const tagsToShow: string[] = [...CATEGORY_TAGS, ...ATTRIBUTE_TAGS];
  return (
    <ul styleName="tag-wrap">
      {tags.map(
        (tag) =>
          tagsToShow.includes(tag) && (
            <li styleName="tag" key={tag}>
              {tag}
            </li>
          )
      )}
    </ul>
  );
};
